<template>
  <div class="e-footer">
    <ul>
      <li @click="$router.push('/m')">
        <div class="e-footer-icon" :class="isIndex">
          <i class="iconfont" :class="isIndex ? 'icon-home-on' : 'icon-home'"></i>
        </div>
        <p>首页</p>
      </li>
      <li @click="go('https://www.aiimooc.com/')">
        <div class="e-footer-icon">
          <i class="iconfont icon-ruimuke"></i>
        </div>
        <p>睿慕课</p>
      </li>
      <li @click="$router.push('/m/my')">
        <div class="e-footer-icon" :class="isMy">
          <i class="iconfont" :class="isMy ? 'icon-my-on' : 'icon-my'"></i>
        </div>
        <p>我的</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
 computed: {
   isIndex () {
     return this.$route.path === '/m' ? 'act' : ''
   },
   isMy () {
     return this.$route.path === '/m/my' ? 'act' : ''
   }
 },
 methods: {
   go (url) {
     window.location.href = url
   }
 }
}
</script>

<style lang="scss" scoped>
.e-footer{
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50px;
  box-shadow: rgba(161, 161, 161, .16) 0 -3px 2px;
  background-color: #fff;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  ul{
    display: flex;
    justify-content: space-around;
    li{
      padding-top: 8px;
      .e-footer-icon{
        width: 22px;
        height: 20px;
        color: #777C81;
        margin: 0 auto;
        text-align: center;
        .iconfont{
          font-size: 22px;
        }
        &.act{
          text-align: center;
          color: #FE445F;
        }
      }
      p{
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        color: #777C81;
      }
    }
  }
}
</style>
